import React, { Component } from 'react'
import SelectSearchLayout from '../../../layouts/select-search'
import * as PropTypes from 'prop-types'
import { connectionOperations } from '../../../../state/ducks/connections'
import { connect } from 'react-redux'
import { ParametersCreatorForm } from '../parameters-creator-form'

class ConciliationDataForm extends Component {
  constructor (props) {
    super(props)

    // state
    this.state = {}

    this.handleChange = this.handleChange.bind(this)
    this.onParametersChange = this.onParametersChange.bind(this)
    this.returnConnectionOptions = this.returnConnectionOptions.bind(this)
    this.onOriginConnectionSearchKeywordChange = this.onOriginConnectionSearchKeywordChange.bind(this)
    this.onSelectOriginConnection = this.onSelectOriginConnection.bind(this)
    this.onSelectDestinationConnection = this.onSelectDestinationConnection.bind(this)
    this.handleBatchOrderChange = this.handleBatchOrderChange.bind(this)
  }

  componentDidMount () {
    if (this.props.connections_list.length) return

    this.props.fetchConnections({})
  }

  handleChange (event) {
    this.props.onChange(event.target.name, event.target.value)
  }

  handleBatchOrderChange (event) {
    this.props.onChange(event.target.name, parseFloat(event.target.value))
  }

  onParametersChange (parametersList) {
    this.props.onChange('parameters', parametersList)
  }

  returnConnectionOptions () {
    const options = []
    this.props.connections_list.forEach(element => {
      options.push({
        value: element.id + '|' + element.name,
        label: element.name
      })
    })
    return options
  }

  onOriginConnectionSearchKeywordChange (keyword) {
    this.returnConnectionOptions()
    this.props.fetchConnections({ search: keyword })
  }

  onSelectOriginConnection (item) {
    const split_ = item.value.split('|')
    // id: split_[0,
    // connection_name: split_[1]
    this.props.onChange('origin_connection', split_[0])
  }

  onSelectDestinationConnection (item) {
    const split_ = item.value.split('|')
    // id: split_[0,
    // connection_name: split_[1]
    this.props.onChange('destination_connection', split_[0])
  }

  render () {
    return (
            <>
                <div className="form-group">
                    <div className="col-sm-8 col-sm-offset-2" style={{ minHeight: '70px' }}>
                        <div className="form-material">
                            <input className="form-control"
                                   type="text"
                                   id="input-name"
                                   placeholder="Please enter a name"
                                   name="name"
                                   value={this.props.conciliation.name}
                                   onChange={this.handleChange}
                            />
                            <label htmlFor="input-name">Name</label>
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-offset-2" style={{ minHeight: '70px' }}>
                        <div className="form-material">
                            <input className="form-control"
                                   type="text"
                                   id="input-description"
                                   placeholder="Please enter a description"
                                   name="description"
                                   value={this.props.conciliation.description}
                                   onChange={this.handleChange}
                            />
                            <label htmlFor="input-name">Description</label>
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-offset-2" style={{ minHeight: '70px' }}>
                        <div className="form-material">
                            <label htmlFor="input-connections">Origin Connection</label>
                            <SelectSearchLayout
                                placeholder={this.props.conciliation.origin_connection ? this.props.conciliation.origin_connection_name : 'Type to search an item...'}
                                getOptions={this.returnConnectionOptions}
                                onSearchChange={this.onOriginConnectionSearchKeywordChange}
                                onSelectItem={this.onSelectOriginConnection}
                            />
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-offset-2" style={{ minHeight: '70px' }}>
                        <div className="form-material">
                            <label htmlFor="input-connections">Destination Connection</label>
                            <SelectSearchLayout
                                placeholder={this.props.conciliation.destination_connection ? this.props.conciliation.destination_connection_name : 'Type to search an item...'}
                                getOptions={this.returnConnectionOptions}
                                onSearchChange={this.onOriginConnectionSearchKeywordChange}
                                onSelectItem={this.onSelectDestinationConnection}
                            />
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-offset-2" style={{ minHeight: '70px' }}>
                        <div className="form-material">
                            <select className="form-control"
                                    id="input-conciliation_type"
                                    name="conciliation_type"
                                    value={this.props.conciliation.conciliation_type}
                                    onChange={this.handleChange}
                            >
                                <option>-</option>
                                <option value={1}>SQL</option>
                                <option value={2}>KeyVsKey</option>
                                <option value={3}>Balance</option>
                            </select>
                            <label htmlFor="input-conciliation_type">Type</label>
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-offset-2">
                        <div className="form-material">
                            <input
                                className="form-control"
                                type="number"
                                id="input-batch_order"
                                name="batch_order"
                                value={this.props.conciliation.batch_order}
                                onChange={this.handleBatchOrderChange}
                            />
                            <label htmlFor="input-batch_order">Batch Order</label>
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-offset-2" style={{ minHeight: '70px' }}>
                        <div className="form-material">
                            <div className="block" id="my-block">
                                <div className="block-header pl-0 pr-0">
                                    <ul className="block-options">
                                        <li>
                                            <button type="button" data-toggle="block-option"
                                                    data-action="fullscreen_toggle"
                                                    onClick={window.jQuery('body').addClass('block-fullscreen')}>
                                                <i className="si si-size-fullscreen"/>
                                            </button>
                                        </li>
                                    </ul>
                                    <h3 className="block-title">Parameters</h3>
                                    <br/>
                                </div>
                                <div className="block-content p-0">
                                    <ParametersCreatorForm
                                        editorType={2}
                                        parameters={this.props.conciliation.parameters}
                                        onParametersChange={this.onParametersChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
    )
  }
}

// Set propTypes
ConciliationDataForm.propTypes = {
  fetchConnections: PropTypes.func.isRequired
}

// Set defaultProps
ConciliationDataForm.defaultProps = {
  conciliation: { parameters: {}, columns: [] },
  onChange: () => {
  }
}

// mapStateToProps
const mapStateToProps = (state) => ({
  connections_list: state.connections.fetchConnectionsReducer.data.results
})

// mapStateToProps
const mapDispatchToProps = {
  fetchConnections: connectionOperations.list
}

// Export Class
const _ConciliationDataForm = connect(mapStateToProps,
  mapDispatchToProps)(ConciliationDataForm)
export { _ConciliationDataForm as ConciliationDataForm }
